"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./chart.component'));
__export(require('./chart.module'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/angular2-chartjs/dist/index.js
// module id = ../../../../angular2-chartjs/dist/index.js
// module chunks = 42